export default [
  {
    name: 'Draft Form Editor',
    path: '/account-forms/draft/edit',
    component: () => import(/* webpackChunkName: "forms" */ '@/views/forms/FormEditorView.vue')
  },
  {
    name: 'Form Editor',
    path: '/account-forms/:id/edit',
    component: () => import(/* webpackChunkName: "forms" */ '@/views/forms/FormEditorView.vue')
  },
  {
    name: 'Account Forms',
    path: '/account-forms/:id?',
    component: () => import(/* webpackChunkName: "forms" */ '@/views/forms/FormListView.vue')
  },
  {
    name: 'Account Packets',
    path: '/account-packets/:id?',
    component: () => import(/* webpackChunkName: "forms" */ '@/views/forms/PacketListView.vue')
  },
  {
    name: 'Pending Submissions',
    path: '/pending-submissions/:id?',
    component: () => import(/* webpackChunkName: "forms" */ '@/views/forms/PendingSubmissionsView.vue')
  },
  {
    name: 'Complete Submissions',
    path: '/complete-submissions/:id?',
    component: () => import(/* webpackChunkName: "forms" */ '@/views/forms/CompleteSubmissionsView.vue')
  },
  {
    name: 'Submission Filler',
    path: '/submission/:privateUrl',
    component: () => import(/* webpackChunkName: "forms" */ '@/views/forms/SubmissionFillerView.vue')
  },
  {
    name: 'Single Form Filler',
    path: '/forms/:formId',
    component: () => import(/* webpackChunkName: "forms" */ '@/views/forms/SubmissionFillerView.vue')
  },
  {
    name: 'Short Form Filler',
    path: '/f/:formId',
    component: () => import(/* webpackChunkName: "forms" */ '@/views/forms/SubmissionFillerView.vue')
  },
  {
    name: 'Packet Filler',
    path: '/packets/:packetId',
    component: () => import(/* webpackChunkName: "forms" */ '@/views/forms/SubmissionFillerView.vue')
  },
  {
    name: 'Short Packet Filler',
    path: '/p/:packetId',
    component: () => import(/* webpackChunkName: "forms" */ '@/views/forms/SubmissionFillerView.vue')
  },
  {
    name: 'Multi Form Filler',
    path: '/multi-forms',
    component: () => import(/* webpackChunkName: "forms" */ '@/views/forms/SubmissionFillerView.vue')
  },
  {
    name: 'Import Submission',
    path: '/import-submission',
    component: () => import(/* webpackChunkName: "forms" */ '@/views/forms/ImportSubmissionView.vue')
  },
  {
    name: 'Office Portal',
    path: '/portal/:officeName',
    component: () => import(/* webpackChunkName: "portal" */ '@/views/forms/OfficePortalView.vue')
  }
]